import { lazy, Suspense } from "react";
import { DashboardSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/overview/main"));


const OverView = () => {
  return (
    <Suspense fallback={<DashboardSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default OverView;



